import { motion } from "framer-motion";
import { Reveal, Overline } from "@/components/primitives";
import { assets } from "@/config/assets";

const CHAPTERS = [
  {
    n: "01",
    title: "People compare before they choose",
    body: "Customers research local businesses online before ever walking in or calling. Your profile is the first impression.",
  },
  {
    n: "02",
    title: "Reviews decide who earns trust",
    body: "Star ratings and recent reviews shape whether someone trusts you enough to spend their money with you.",
  },
  {
    n: "03",
    title: "Weak visibility quietly loses customers",
    body: "Businesses that are hard to find, or that look inactive, lose customers to competitors who show up first.",
  },
  {
    n: "04",
    title: "AI is changing how people discover",
    body: "Tools like ChatGPT, Gemini, and Perplexity now recommend businesses. What they understand about you matters.",
  },
];

export default function Problem() {
  return (
    <section id="problem" className="relative overflow-hidden bg-black py-24 text-white lg:py-32">
      <div className="pointer-events-none absolute inset-0 bg-grid-dark opacity-70" />
      <img
        src={assets.lifestyle.coffeeCounter}
        alt=""
        className="pointer-events-none absolute right-0 top-0 h-full w-1/2 object-cover opacity-[0.14] [mask-image:linear-gradient(to_left,black,transparent)]"
      />

      <div className="relative mx-auto max-w-[1280px] px-5 sm:px-8">
        <Reveal>
          <Overline dark>The reality of local business today</Overline>
        </Reveal>
        <Reveal delay={0.05}>
          <h2 className="mt-6 max-w-4xl text-4xl font-black leading-[1.02] tracking-tighter sm:text-5xl lg:text-6xl">
            Your online reputation impacts every buying decision
          </h2>
        </Reveal>

        <div className="mt-16 grid grid-cols-1 gap-px overflow-hidden rounded-[10px] border border-white/10 bg-white/10 md:grid-cols-2">
          {CHAPTERS.map((c, i) => (
            <Reveal
              key={c.n}
              delay={i * 0.08}
              className="group bg-black p-8 transition-colors duration-300 hover:bg-white/[0.04] lg:p-10"
            >
              <div className="flex items-baseline gap-4">
                <span className="font-mono text-sm font-medium text-white/40">{c.n}</span>
                <h3 className="text-xl font-medium tracking-tight sm:text-2xl">{c.title}</h3>
              </div>
              <p className="mt-4 max-w-md pl-10 text-base font-light leading-relaxed text-white/55">
                {c.body}
              </p>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.1}>
          <p className="mt-16 max-w-3xl text-2xl font-light leading-snug tracking-tight text-white sm:text-3xl">
            Your reputation is no longer just what people say about you.
            <span className="text-white/45">
              {" "}It is what search engines and AI platforms understand about your business.
            </span>
          </p>
        </Reveal>
      </div>
    </section>
  );
}
